import React, { PropsWithChildren } from "react";
import { ThemeProvider, BaseStyles } from "@primer/react";
import { StyleSheetManager } from "styled-components";
import ErrorHandler from "./ErrorHandler";

// Mirrors ChakraProviderWithNonce's role on the Primer side. `disableCSSOMInjection`
// forces styled-components to write rule text into the <style> tag's text content
// instead of using insertRule() into the CSSOM. Without it, Turbo Drive's <head>
// merge can deduplicate the empty tags and silently drop their rules — same
// mechanism the Chakra CacheProvider already mitigates via speedy: false.
export default function PrimerRoot({ children }: PropsWithChildren): React.ReactElement {
  return (
    <ErrorHandler>
      <StyleSheetManager disableCSSOMInjection>
        <ThemeProvider>
          <BaseStyles>{children}</BaseStyles>
        </ThemeProvider>
      </StyleSheetManager>
    </ErrorHandler>
  );
}
